import { SetBuyReturnLabelActionStep } from "@redotech/redo-flows-common/oms/actions";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { memo } from "react";
import { PartialWithRequiredType } from ".";

export const BuyReturnLabelToggle = memo(function BuyReturnLabelToggle({
  step,
  setStep,
}: {
  step: PartialWithRequiredType<SetBuyReturnLabelActionStep>;
  setStep: (step: PartialWithRequiredType<SetBuyReturnLabelActionStep>) => void;
}) {
  const { t } = useTranslation();
  return (
    <RedoToggle
      label={t("Create prepaid return label")}
      setValue={(value) => setStep({ ...step, buyReturnLabel: value })}
      size="xs"
      value={step.buyReturnLabel ?? false}
    />
  );
});
